import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAllFaqApi = (params) => api.get("faq/get-all-trader-faq", { params });
